import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { LoginToken, reqData } from "../../../js/server.js";
import { cloneObj, fnNotLogin, idCheck, pwCheck } from "../../../js/util";
import SubBanner from "../../comm/SubBanner";
import CreateMemberInfo from "./components/CreateMemberInfo";
import ShopMemberInfo from "./components/ShopMemberInfo.js";
import ViewMemberInfo from "./components/ViewMemberInfo";

function MemberInfo(props) {
    const history = useHistory();
    const dispatch = useDispatch();
    const [myinfo, setMyinfo] = useState({});
    const [newAccount, setNewAccount] = useState({});
    const [userToken, setUserToken] = useState(null);
    const [userType, setUserType] = useState("");
    const [users, setUsers] = useState([]);

    const fetchData = (_userToken) => {
        const jsonData = {
            servicename: "MyView",
            userToken: _userToken,
        };
        reqData(jsonData)
            .then((res) => {
                if (res.data.result === "OK") {
                    setMyinfo(res.data.jsonData);

                    fnShopData();
                } else {
                    alert(res.data.msg);
                }
            })
            .catch((err) => {
                console.error(err);
            })
            .finally(() => {
                dispatch({ type: "loadingChange", payload: false });
            });
    };

    const userHandleChange = (e) => {
        const dataType = e.target.dataset["type"];
        //숫자타입인데 문자가 들어오는 경우 false
        let isState = true;
        if (dataType === "int") {
            if (isNaN(e.target.value)) {
                isState = false;
            }
        }
        if (isState) {
            let copiedObj = cloneObj(myinfo);
            copiedObj[e.target.name] = e.target.value;
            setMyinfo(copiedObj);
        }
    };

    const newHandleChange = (e) => {
        const dataType = e.target.dataset["type"];
        //숫자타입인데 문자가 들어오는 경우 false
        let isState = true;
        if (dataType === "int") {
            if (isNaN(e.target.value)) {
                isState = false;
            }
        }
        if (isState) {
            let copiedObj = cloneObj(newAccount);
            copiedObj[e.target.name] = e.target.value;
            setNewAccount(copiedObj);
        }
    };

    const fnSaveClick = () => {
        const userPwState = pwCheck(myinfo.new_passwd);
        const userRePwState = pwCheck(myinfo.new_re_passwd);

        if (!myinfo.username) {
            alert("이름을 입력해 주세요.");
            document.querySelector("#username").focus();
        } else if (!myinfo.hp) {
            alert("휴대전화번호를 입력해 주세요.");
            document.querySelector("#hp").focus();
        } else if (!myinfo.passwd) {
            alert("현재비밀번호를 입력해 주세요.");
            document.querySelector("#passwd").value = "";
            document.querySelector("#passwd").focus();
        } else if (myinfo.new_passwd !== myinfo.new_re_passwd) {
            alert("변경할 비밀번호와 변경확인에 입력한 값이 다릅니다.");
            document.querySelector("#new_passwd").focus();
        } else if (myinfo.new_passwd && !userPwState) {
            alert("비밀번호는 영문,숫자 포함 6~20자내 사용이 가능합니다.");
            document.querySelector("#new_passwd").focus();
        } else if (myinfo.new_re_passwd && !userRePwState) {
            alert("비밀번호는 영문,숫자 포함 6~20자내 사용이 가능합니다.");
            document.querySelector("#new_re_passwd").focus();
        } else {
            if (window.confirm("수정하시겠습니까?")) {
                const jsonData = {
                    servicename: "MySave",
                    userToken: userToken,
                    jsonData: {
                        userid: myinfo.userid,
                        username: myinfo.username,
                        hp: myinfo.hp,
                        passwd: myinfo.passwd,
                        new_passwd: myinfo.new_passwd,
                    },
                };

                dispatch({ type: "loadingChange", payload: true });
                reqData(jsonData)
                    .then((res) => {
                        if (res.data.result === "OK") {
                            alert("변경되었습니다.");
                            history.goBack();
                        } else {
                            alert(res.data.msg);
                        }
                    })
                    .catch((err) => {
                        console.error(err);
                    })
                    .finally(() => {
                        dispatch({ type: "loadingChange", payload: false });
                    });
            }
        }
    };

    const fnCreateClick = () => {
        const userIdState = idCheck(newAccount.userid);
        const userPwState = pwCheck(newAccount.passwd);

        if (!newAccount.userid || !userIdState) {
            alert("사용자 아이디는 6~20자내 사용이 가능합니다. (영문,숫자 가능)");
            document.querySelector("#_userid").focus();
        } else if (!newAccount.username) {
            alert("이름을 입력해 주세요.");
            document.querySelector("#_username").focus();
        } else if (!newAccount.hp) {
            alert("휴대전화번호를 입력해 주세요.");
            document.querySelector("#_hp").focus();
        } else if (!newAccount.passwd || !userPwState) {
            alert("비밀번호는 영문,숫자 포함 6~20자내 사용이 가능합니다.");
            document.querySelector("#_passwd").focus();
        } else {
            if (window.confirm("등록하시겠습니까?")) {
                const jsonData = {
                    servicename: "MyCreate",
                    userToken: userToken,
                    jsonData: {
                        comcode: "0000000000",
                        userid: newAccount.userid,
                        username: newAccount.username,
                        hp: newAccount.hp,
                        passwd: newAccount.passwd,
                    },
                };

                dispatch({ type: "loadingChange", payload: true });
                reqData(jsonData)
                    .then((res) => {
                        if (res.data.result === "OK") {
                            alert("등록되었습니다.");
                            setNewAccount({});
                            fnShopData();
                        } else {
                            alert(res.data.msg);
                        }
                    })
                    .catch((err) => {
                        console.error(err);
                    })
                    .finally(() => {
                        dispatch({ type: "loadingChange", payload: false });
                    });
            }
        }
    };

    //사용자정보 저장
    const fnUserSaveClick = (idx, e) => {
        const jsonData = {
            servicename: "MemberSave",
            userToken: userToken,
            jsonData: users[idx],
        };

        dispatch({ type: "loadingChange", payload: true });
        reqData(jsonData)
            .then((res) => {
                if (res.data.result === "OK") {
                    alert("저장되었습니다.");
                } else {
                    alert(res.data.msg);
                }
            })
            .catch((err) => {
                console.error(err);
            })
            .finally(() => {
                dispatch({ type: "loadingChange", payload: false });
            });
    };

    //사용자정보 삭제
    const fnUserDeleteClick = (idx, e) => {
        if (
            window.confirm(`[${users[idx].userid}] 회원정보를 삭제 하시겠습니까?`)
        ) {
            const jsonData = {
                servicename: "MemberDelete",
                userToken: userToken,
                userid: users[idx].userid,
            };

            dispatch({ type: "loadingChange", payload: true });
            reqData(jsonData)
                .then((res) => {
                    if (res.data.result === "OK") {
                        alert("삭제되었습니다.");

                        let copiedObj = cloneObj(users);
                        copiedObj.splice(idx, 1);
                        setUsers(copiedObj);
                    } else {
                        alert(res.data.msg);
                    }
                })
                .catch((err) => {
                    console.error(err);
                })
                .finally(() => {
                    dispatch({ type: "loadingChange", payload: false });
                });
        }
    };

    const fnShopData = () => {
        const jsonData = {
            servicename: "ShopView",
            userToken: userToken,
            comcode: "0000000000",
        };

        dispatch({ type: "loadingChange", payload: true });
        reqData(jsonData)
            .then((res) => {
                if (res.data.result === "OK") {
                    setUsers(res.data.jsonUser);
                } else {
                    alert(res.data.msg);
                }
            })
            .catch((err) => {
                console.error(err);
            })
            .finally(() => {
                dispatch({ type: "loadingChange", payload: false });
            });
    };

    useEffect(
        () => {
            dispatch({
                type: "pageChange",
                payload: { sub01: "회원관리", sub02: "내정보수정" },
            });
            dispatch({ type: "loadingChange", payload: true });

            setTimeout(() => {
                //로그인 체크
                const userinfo = JSON.parse(localStorage.getItem("userinfo"));
                if (userinfo) {
                    const _userToken = userinfo.userToken;
                    setUserToken(_userToken);
                    //로그인 체크 후 Usertype 검사
                    LoginToken(_userToken)
                        .then((res) => {
                            if (res.data.result === "OK") {
                                fetchData(_userToken);
                                setUserType(res.data.jsonData.usertype);
                            } else {
                                fnNotLogin();
                            }
                        })
                        .catch((err) => {
                            console.error(err);
                            localStorage.removeItem("userinfo");

                            fnNotLogin();
                        })
                        .finally(() => {
                            dispatch({ type: "loadingChange", payload: false });
                        });
                } else {
                    fnNotLogin();
                }
            }, 500);
        },
        // eslint-disable-next-line
        []
    );

    return (
        <>
            <SubBanner id="member" />

            <section className="memberinfo section">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <h2>내정보수정</h2>
                            <span>
                                내 계정의 이름, 비밀번호 등을 수정할 수 있으며 업체정보는 조합에
                                요청해 주세요.
                            </span>
                        </div>
                    </div>

                    <div className="container mt-30 pb-20">
                        <div className="row round-box">
                            <ShopMemberInfo myinfo={myinfo} />
                        </div>

                        <div className="row round-box mt-30">
                            <ViewMemberInfo
                                myinfo={myinfo}
                                userHandleChange={userHandleChange}
                                fnSaveClick={fnSaveClick}
                            />
                        </div>

                        {userType === "0" ? (
                            <>
                                <CreateMemberInfo
                                    newAccount={newAccount}
                                    newHandleChange={newHandleChange}
                                    fnCreateClick={fnCreateClick}
                                    users={users}
                                    setUsers={setUsers}
                                    fnUserSaveClick={fnUserSaveClick}
                                    fnUserDeleteClick={fnUserDeleteClick}
                                />
                            </>
                        ) : null}
                    </div>
                </div>
            </section>
        </>
    );
}

export default MemberInfo;
